const React = require('react');

const ArtistItemContainer = require('./ItemContainer.jsx');
const ArtistMeta = require('./ArtistMeta.jsx');
const ArtistName = require('./Name.jsx');
const Bio = require('./Bio.jsx');
const CommonTypes = require('../common/Types.jsx');
const Config = require('../utility/Config.jsx');
const ContentContainer = require('../common/ContentContainer.jsx');
const CV = require('./CV.jsx');
const Image = require('./Image.jsx');
const _ItemContainerV2 = require('../common/ItemContainerV2.jsx');
const _ItemContainer = require('../common/ItemContainer.jsx');
const Name = require('../utility/Name.jsx');
const Token = require('../utility/Token.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

const ArtistBlocks = {
    get: (group, data) => [
        ...CommonTypes.BlocksV2.content.get(group),
        {
            id: Name.Block.Artist.Image,
            component: Image.Component,
            config: {
                Block: Image.TypeConfigV2.panel.block(),
                Style: Image.TypeConfigV2.panel.style()
            },
            display: 'Artist Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Artist.Meta,
            component: ArtistMeta.Component,
            config: {
                Block: ArtistMeta.TypeConfig.panel.block(),
                Style: ArtistMeta.TypeConfig.panel.style(),
                Description: ArtistMeta.TypeConfig.panel.description(),
                Label: ArtistMeta.TypeConfig.panel.label(),
                Value: ArtistMeta.TypeConfig.panel.value()
            },
            display: 'Artist Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Container,
            component: ArtistItemContainer.ComponentV2,
            config: {
                Block: ArtistItemContainer.TypeConfigV2.panel.block(),
                Style: ArtistItemContainer.TypeConfigV2.panel.style(),
                Visibility: ArtistItemContainer.TypeConfigV2.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ArtistItemContainer.TypeConfigV2.defaultDesign(data) }
                ]
            },
            display: 'Item Container',
            group,
            image: '',
            type: 'container'
        }
    ]
}

function ArtistContainerV2(props) {
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    return (
        <ArtistContainer
            {...props}
            itemContentContainer={ArtistContentContainer}
            v2={true}
            visibility={props.config && props.config.config && props.config.config.Visibility}
            visibilityHash={visibilityHash} />
    )
}

const _ArtistContentContainer = Config.withBlockRendering(ContentContainer, ArtistBlocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
    }
});
function ArtistContentContainer(props) {
    let config = props.contentConfig;
    if (!config && props.config && props.config.config && props.config.config.Block && props.config.config.Block.design && props.config.config.Block.design.Config) {
        config = Utilities.Config.getDeepCopy(props.config.config.Block.design);
    }
    let componentData;
    if (props.componentData) {
        componentData = props.componentData;
        if (componentData && componentData.length) {
            componentData = componentData[0];
        }
    } else if (props.data && props.data.Artists && props.data.Artists.length) {
        componentData = { itemData: { ...props.data.Artists[0] } };
    }
    if (!componentData) {
        componentData = {};
    }
    return <_ArtistContentContainer {...props} {...componentData} contentConfig={config} />
}

const TypeConfigV2 = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "maxHeight": {
                                "unit": "px",
                                "value": "600"
                            },
                            "maxWidth": {
                                "unit": "px",
                                "value": "600"
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Artist.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {},
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ArtistMeta.TypeConfig.defaultDesign
                        }
                    },
                    "id": `${Name.Block.Artist.Meta}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.ArtistBioItem
    }),
    panel: {
        block: () => _ItemContainerV2.TypeConfig.panel.block('block', Name.Content.ArtistBioItem),
        style: () => TypeConfig.panel.layoutStyleV2('block', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Artist Name', name: Token.Artist.Name, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Name, config, Name.Block.Artist.Meta) },
                    { display: 'Birthdate', name: Token.Artist.Birthdate, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Birthdate, config, Name.Block.Artist.Meta) },
                    { display: 'Deathdate', name: Token.Artist.Deathdate, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Deathdate, config, Name.Block.Artist.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

// #region LEGACY

class ArtistContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handleComponentType = this.handleComponentType.bind(this);
    }

    handleComponentType(type) {
        switch (type) {
            case 'bio':
                return Bio.Component;
            case 'cv':
                return CV.Component;
            case 'image':
                return Image.Component;
            case 'inventoryContainer':
                return ArtistItemContainer.Component;
            case 'name':
                return ArtistName.Component;
            default:
                return null;
        }
    }

    render() {
        const data = this.props.data || {};
        let className = 'itemContainer';
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        const PageComponent = this.props.v2 ? _ItemContainerV2.Page : _ItemContainer.Page;
        return (
            <PageComponent
                {...this.props}
                className={className}
                items={data.Artists}
                onComponentType={this.handleComponentType} />
        );
    }
}

// #endregion LEGACY

module.exports = {
    Blocks: ArtistBlocks,
    ContentContainer: ArtistContentContainer,
    PageV2: ArtistContainerV2,
    TypeConfigV2,

    // LEGACY
    Page: ArtistContainer,
    TypeConfig: _ItemContainer.TypeConfig
};